import type { TAuth } from "@/types"
import { hasAdmin } from "./permissions"

// Check roles
export const authorized = (auth: TAuth) => !!auth.user
export const anonymous = () => true
export const anonymousOnly = (auth: TAuth) => !auth.user
export const adminOnly = ({ user }: TAuth) => !!user && hasAdmin(user)
